/* create by ma.rongqin 2016/10/18*/
'use strict';
angular.module('manageSysManageSourceManageModule', [
    'manageSysManageSourceManageNewModule',
    'manageSysManageSourceManageSyncModule'
])
    .controller('manageSysManageSourceManageCtrl', ['$scope', '$q', '$modal', 'trsHttpService', 'modalDialog', 'trsspliceString',
        function($scope, $q, $modal, trsHttpService, modalDialog, trsspliceString) {
            initStatus();
            initData();

            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 20,
                    'ITEMCOUNT': 0,
                    'PAGECOUNT': 1
                };
                $scope.params = {
                    'serviceid': 'mlf_source',
                    'methodname': 'querySources',
                    'PageSize': $scope.page.PAGESIZE,
                    'CurrPage': $scope.page.CURRPAGE,
                };
                $scope.status = {
                    batchOperateBtn: {
                        'hoverStatus': '',
                        'clickStatus': ''
                    },
                    copyCurrPage: 1,
                };
                $scope.data = {
                    selectedArray: [],
                    items: [],
                };
            }

            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestData();
            }

            /**
             * [requestData description:请求数据]
             */
            function requestData() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    $scope.data.items = data.DATA;
                    for (var i in $scope.data.items) {
                        if (typeof ($scope.data.items[i].SRCDESC) === 'object') {
                            $scope.data.items[i].SRCDESC = JSON.stringify($scope.data.items[i].SRCDESC);
                        }
                        if (typeof ($scope.data.items[i].SRCNAME) === 'object') {
                            $scope.data.items[i].SRCNAME = JSON.stringify($scope.data.items[i].SRCNAME);
                        }
                    }!!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                    $scope.data.selectedArray = [];

                });
            }

            /**
             * [pageChanged description:下一页]
             */
            $scope.pageChanged = function() {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description:跳转指定页面]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };

            /**
             * [selectPageNum description:选择单页显示个数]
             */
            $scope.selectPageNum = function() {
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = 1;
                requestData();
            };

            /**
             * [selectAll description:全选]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
                cancelBatchOperate();
            };

            /**
             * [selectDoc 单选]
             * @param  {[type]} item [description：单个对象] 
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
                cancelBatchOperate();
            };

            /**
             * [cancelBatchOperate description：取消批量操作的样式]
             */
            function cancelBatchOperate() {
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.batchOperateBtn = {
                        'hoverStatus': '',
                        'clickStatus': ''
                    };
                }
            }

            /**
             * [newModel description：新建/编辑弹窗]
             */
            function newModel(item, successFn) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/sourceManage/view/new_tpl.html',
                    windowClass: 'sysMgr-sourMgr-newView',
                    backdrop: false,
                    controller: 'manageSysManageSourceManageNewCtrl',
                    resolve: {
                        curItem: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    successFn(result);
                });
            }

            /**
             * [syncModal description]同步来源
             * @return {[type]} [description]
             */
            $scope.sync = function() {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/sourceManage/view/sync/sync_tpl.html',
                    windowClass: 'sysMgr-sourMgr-syncView',
                    backdrop: false,
                    controller: 'manageSysManageSourceManageSyncCtrl',
                    resolve: {
                        
                    }
                });
                modalInstance.result.then(function(result) {
                    initData(); // 初始化
                });
            };

            /**
             * [new description：新建]
             */
            $scope.new = function() {
                newModel('', function(result) {
                    var params = {
                        'serviceid': 'mlf_source',
                        'methodname': 'saveSource',
                        'SourceId': '',
                        'SrcName': result.sourceName,
                        'SrcDesc': result.sourceDescribe,
                        'SrcLink': result.sourceLink || '',
                        'SiteId': '0',
                        'FrontSourceName': '-1'
                    };
                    save(params, '新建成功');
                });
            };

            /**
             * [edit description：修改]
             */
            $scope.edit = function(item) {
                newModel(item, function(result) {
                    var params = {
                        'serviceid': 'mlf_source',
                        'methodname': 'saveSource',
                        'SourceId': item.SOURCEID,
                        'SrcName': result.sourceName,
                        'SrcDesc': result.sourceDescribe,
                        'SrcLink': result.sourceLink || '',
                        'SiteId': '0',
                        'FrontSourceName': '-1'
                    };
                    save(params, '修改成功');
                });
            };

            /**
             * [save description：保存]
             */
            function save(params, tip) {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType(tip, '', 'success', false, function() {
                        requestData();
                    });
                });
            }

            /**
             * [refresh description：刷新]
             */
            $scope.refresh = function() {
                $scope.params.CurrPage = 1;
                $scope.page.CURRPAGE = 1;
                $scope.status.copyCurrPage = 1;
                requestData();
            };

            /**
             * [delete description：删除]
             */
            $scope.delete = function() {
                var info = '确定删除';
                if ($scope.data.selectedArray.length > 1) {
                    var title1 = handleTitle($scope.data.selectedArray[0].SRCNAME, 10);
                    var title2 = handleTitle($scope.data.selectedArray[1].SRCNAME, 10);
                    info += '【' + title1 + '】【' + title2 + '】' + '等' + $scope.data.selectedArray.length + '个来源？';
                } else {
                    info += '【' + handleTitle($scope.data.selectedArray[0].SRCNAME, 10) + '】？';
                }
                modalDialog.confirmModal('删除', info, function() {
                    var params = {
                        'serviceid': 'mlf_source',
                        'methodname': 'removeSources',
                        'SourceIds': trsspliceString.spliceString($scope.data.selectedArray, 'SOURCEID', ','),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('删除成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            };

            /**
             * [singleDelete description：单项删除]
             */
            $scope.singleDelete = function(item) {
                var info = '确定删除';
                info += '【' + handleTitle(item.SRCNAME, 10) + '】？';
                modalDialog.confirmModal('删除', info, function() {
                    var params = {
                        'serviceid': 'mlf_source',
                        'methodname': 'removeSources',
                        'SourceIds': trsspliceString.spliceString([item], 'SOURCEID', ','),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('删除成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            };

            /**
             * [handleTitle description] 处理标题长度
             * @param {[string]} [title] [description]
             * @param {int} [number] [description] 截取长度
             * @return {[type]} [description]
             */
            function handleTitle(title, number) {
                return title.length > number ? title.substring(0, number) + '...' : title;
            }

            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下空格也能提交]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.params.allField = $scope.keywords;
                    $scope.params.CurrPage = 1;
                    $scope.page.CURRPAGE = 1;
                    $scope.status.copyCurrPage = 1;
                    requestData();
                }
            };
        }
    ]);
